import React, { PropsWithChildren, useState } from 'react';
import { ImageProps } from 'react-native';

export type CheckImageType = 'front' | 'back';

type ImageDataMap = Record<string, Record<CheckImageType, ImageProps>>;

export type RDCContextProps = {
  clear: () => void;
  saveImage: (
    depositFlowId: string,
    key: CheckImageType,
    img: ImageProps,
  ) => void;
  getImage: (
    depositFlowId: string,
    key: CheckImageType,
  ) => ImageProps | null | undefined;
};

const saveImage =
  (imageMap: ImageDataMap, setImageMap: (ImageDataMap) => void) =>
  (depositFlowId: string, key: CheckImageType, img: ImageProps) => {
    const sessionImgs = imageMap[depositFlowId] ?? {};
    sessionImgs[key] = img;
    setImageMap({ ...imageMap, [depositFlowId]: sessionImgs });
  };

export const RDCContext = React.createContext<RDCContextProps>({
  clear: () => {},
  saveImage: () => {},
  getImage: () => null,
});

const RDCContextProvider = ({ children }: PropsWithChildren) => {
  const [imageMap, setImageMap] = useState<ImageDataMap>({});
  return (
    <RDCContext.Provider
      value={{
        clear: () => {
          setImageMap({});
        },
        saveImage: saveImage(imageMap, setImageMap),
        getImage: (depositFlowId: string, key: CheckImageType) => {
          if (!depositFlowId || !key) {
            return null;
          }

          const sessionImgs = imageMap[depositFlowId];
          if (!sessionImgs) {
            return null;
          }

          return sessionImgs[key];
        },
      }}
    >
      {children}
    </RDCContext.Provider>
  );
};

export default RDCContextProvider;
